export enum ExpressOrderItemType {
  Product = 'product',
  Fee = 'fee',
}

export type ExpressOrderItem = {
  id: string;
  name: string;
  price: string;
  quantity: number;
  type: ExpressOrderItemType;
};

export type ExpressPaymentBreakdown = {
  shipping: string;
  tax: string;
  discount: string;
};

export type ExpressShippingMethod = {
  label: string;
  amount: string;
  identifier: string;
  detail: string;
};

export type ExpressPaymentData = {
  orderItems: ExpressOrderItem[];
  paymentBreakdown: ExpressPaymentBreakdown;
  paymentAmount: string;
};

export enum ExpressCheckoutButtonsState {
  LOADING = 'LOADING',
  LOADED_WITHOUT_BUTTONS = 'LOADED_WITHOUT_BUTTONS',
  LOADED_WITH_BUTTONS = 'LOADED_WITH_BUTTONS',
}

export type ExpressWidgetMeta = {
  appDefId: string;
  appInstanceId: string;
  siteId: string;
  visitorId: string;
  siteOwnerId?: string;
  appInstance: string;
  consumerWidgetId: string;
};

export type ExpressButtonsData = {
  locale: string;
  domain: string;
  meta: ExpressWidgetMeta;
  isExpressSupported: boolean;
  isPremium: boolean;
  canBusinessShip: boolean;
  isOwner: boolean;
  viewMode: string;
  isMobile: boolean;
  upgradeUrl: string;
  shippingSettingsUrl: string;
};
